import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { handleError } from "../../../../utils/ErrorHandler";

const initialState = {
	list: [],
	franchiseSubmitting:false,
	assigningSlots:false,
	applyingDiscount:false,
	user: null,
	error: "",
	loading: false,
};

export const addStaff = createAsyncThunk("user/addStaff", async (values) => {
	try {
		const { data } = await axios({
			method: "post",
			headers: {
				Accept: "application/json",
				headers: { "Content-Type": "multipart/form-data" },
			},
			url: `user/register`,
			data: values,
		});
		toast.success("Registration successful");
		return {
			data,
			message: "success",
		};
	} catch (error) {
		const errorMessage =
			error.response && error.response.data && error.response.data.message
				? error.response.data.message
				: "Error in adding franchise try again";
		toast.error(errorMessage);
		console.log(error.message);
		return {
			message: "error",
		};
	}
});

export const updateStaff = createAsyncThunk("user/updateStaff", async ({ id, formData }) => {
	try {
		const { data } = await axios({
			method: "put",
			headers: {
				Accept: "application/json",
				headers: { "Content-Type": "multipart/form-data" },
			},
			url: `user/${id}`,
			data: formData,
		});
		toast.success("Franchise Updated Successfully");
		return {
			data,
			message: "success",
		};
	} catch (error) {
		const errorMessage = error?.response?.data?.message || "Error in adding staff. Please try again.";
		toast.error(errorMessage);
		return {
			message: "error",
		};
	}
});

export const addApplyDiscount = createAsyncThunk("user/addDiscount", async (values) => {
	try {
		const { data } = await axios({
			method: "post",
			url: "user/player-discount",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			data: values,
		});
		toast.success("Discount applied successfully!");
		return {
			data,
			message: "success",
		};
	} catch (error) {
		toast.error("Error applying discount, please try again.");
		console.error(error.message);
		return {
			message: "error",
		};
	}
});

export const loadFranchiseDiscount = createAsyncThunk("user/franchiseDiscount",
	async (id) => {
		try {
			const data = await axios.get(`user/player-discount/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	});

export const deleteStaff = createAsyncThunk("user/deleteStaff", async (id) => {
	try {
		const resp = await axios({
			method: "patch",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `user/${id}`,
			data: {
				status: false,
			},
		});
		toast.success("Franchise Deleted Successfully!")
		return resp.data;
	} catch (error) {
		console.log(error.message);
	}
});

export const loadSingleStaff = createAsyncThunk(
	"user/loadSingleStaff",
	async (id) => {
		try {
			const data = await axios.get(`user/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const getAllSlotsFranchise = createAsyncThunk(
	"slots/getAllSlotsFranchies",
	async () => {
		try {
			const response = await axios.get(`crm-task/?query=all`);
			console.log("API Response:", response.data);

			return Array.isArray(response.data) ? response.data : [];
		} catch (error) {
			console.error("Error fetching slot data:", error.message);
			throw error;
		}
	}
);
export const assignSlots = createAsyncThunk(
	"slots/assignSlots",
	async (data) => {
		try {
			const response = await axios.post(
				`crm-task/slots`,
				JSON.stringify(data),
				{
					headers: {
						"Content-Type": "application/json",
					},
				}
			);
			
			return response.data;
		} catch (error) {
			throw(error)
		}
	}
);


export const loadAllStaff = createAsyncThunk(
	"user/loadAllStaff",
	async ({ status }) => {
		try {
			const { data } = await axios.get(`user?status=${status}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const addUser = createAsyncThunk("user/addUser", async (values) => {
	try {
		const { data } = await axios({
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `user/login`,
			data: {
				...values,
			},
		});
		localStorage.setItem("access-token", data.token);
		localStorage.setItem("role", data.role);
		localStorage.setItem("user", data.userName);
		localStorage.setItem("id", data.id);
		localStorage.setItem("isLogged", true);
		toast.success(" Login Successfully Done");

		return {
			data,
			message: "success",
		};
	} catch (error) {
		console.log(error.message);
		toast.error("Incorrect Username or Password !");
		return {
			message: "error",
		};
	}
});

// Add Customer Login

export const addCustomer = createAsyncThunk(
	"user/addCustomer",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `customer/login`,
				data: {
					...values,
				},
			});
			localStorage.setItem("access-token", data.token);
			localStorage.setItem("email", data.email);
			localStorage.setItem("fullName", data.firstName + " " + data.lastName);
			localStorage.setItem("id", data.id);
			localStorage.setItem("isLogged", true);
			toast.success(" Login Successfully Done");

			return {
				data,
				message: "success",
			};
		} catch (error) {
			console.log(error.message);
			toast.error("Incorrect Username or Password !");
			return {
				message: "error",
			};
		}
	}
);

//Customer Registration

export const customerRegister = createAsyncThunk(
	"user/customerRegister",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `customer/register`,
				data: {
					...values,
				},
			});
			toast.success("Registration successful");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding customer try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);
//Customer forget password

export const customerForgetPassword = createAsyncThunk(
	"user/customerForgetPassword",
	async (values) => {
		try {
			const { data } = await axios({
				method: "patch",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `customer/forgot-password`,
				data: {
					...values,
				},
			});
			toast.success("Password reset successful");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in password reset try again");
			return {
				message: "error",
			};
		}
	}
);

// Update User Information

export const updateUser = createAsyncThunk(
	"user/updateUser",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",
				url: `user/${id}`,
				data: {
					...values,
				},
			});
			toast.success("User Information Updated Successfully");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			console.log(error.message);
			toast.error("Error in updating user information");
			return {
				message: "error",
			};
		}
	}
);
export const getAWSImage = createAsyncThunk(
	"user/getAWSImage",
	async (fileUrl, { rejectWithValue }) => {
	  try {
		const { data } = await axios.post(`files/aws`, {fileUrl});
		return data;
	  } catch (error) {
		const errorMessage = handleError(error, "Failed to fetch image");
		return rejectWithValue(errorMessage);
	  }
	}
  );
  

const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		clearUser: (state) => {
			state.user = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for loadAllStaff ======

		builder.addCase(loadAllStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllStaff.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loadAllStaff.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addStaff ======

		builder.addCase(addStaff.pending, (state) => {
			state.franchiseSubmitting = true;
		});

		builder.addCase(addStaff.fulfilled, (state, action) => {
			state.franchiseSubmitting = false;
		});

		builder.addCase(addStaff.rejected, (state, action) => {
			state.franchiseSubmitting = false;
			state.error = action.payload.message;
		});
		builder.addCase(updateStaff.pending, (state) => {
			state.franchiseSubmitting = true;
		});

		builder.addCase(updateStaff.fulfilled, (state, action) => {
			state.franchiseSubmitting = false;
		});

		builder.addCase(updateStaff.rejected, (state, action) => {
			state.franchiseSubmitting = false;
			state.error = action.payload.message;
		});
		builder.addCase(assignSlots.pending, (state) => {
			state.assigningSlots = true;
		});

		builder.addCase(assignSlots.fulfilled, (state, action) => {
			state.assigningSlots = false;
		});

		builder.addCase(assignSlots.rejected, (state, action) => {
			state.assigningSlots = false;
			// state.error = action.payload.message;
		});
		builder.addCase(addApplyDiscount.pending, (state) => {
			state.applyingDiscount = true;
		});

		builder.addCase(addApplyDiscount.fulfilled, (state, action) => {
			state.applyingDiscount = false;
		});

		builder.addCase(addApplyDiscount.rejected, (state, action) => {
			state.applyingDiscount = false;
			state.error = action.payload.message;
		});

		// builders for dicount code end


		// 3) ====== builders for addUser ======

		builder.addCase(addUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addUser.fulfilled, (state, action) => {
			state.loading = false;

			if (!Array.isArray(state.user)) {
				state.user = [];
			}
			const user = [...state.user];
			user.push(action.payload.data);
			state.user = user;
		});

		builder.addCase(addUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for addCustomer ======

		builder.addCase(addCustomer.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addCustomer.fulfilled, (state, action) => {
			state.loading = false;

			if (!Array.isArray(state.user)) {
				state.user = [];
			}
			const user = [...state.user];
			user.push(action.payload.data);
			state.user = user;
		});

		builder.addCase(addCustomer.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for customerRegister ======

		builder.addCase(customerRegister.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(customerRegister.fulfilled, (state, action) => {
			state.loading = false;

			if (!Array.isArray(state.user)) {
				state.user = [];
			}
			const user = [...state.user];
			user.push(action.payload.data);
			state.user = user;
		});

		builder.addCase(customerRegister.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		// 3) ====== builders for customerForgetPassword ======

		builder.addCase(customerForgetPassword.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(customerForgetPassword.fulfilled, (state, action) => {
			state.loading = false;
			state.error = false;
		});

		builder.addCase(customerForgetPassword.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for updateUser ======

		builder.addCase(updateUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateUser.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for loadSingleStaff ======

		builder.addCase(loadSingleStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleStaff.fulfilled, (state, action) => {
			state.loading = false;
			console.log("this is the data", state, action)
			state.user = action.payload.data;
		});

		builder.addCase(loadSingleStaff.rejected, (state, action) => {
			state.loading = false;
			console.log(action.payload);
			state.error = action.payload.message;
		});

		// 5) ====== builders for deleteStaff ======

		builder.addCase(deleteStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteStaff.fulfilled, (state, action) => {
			state.loading = false;

			const filterUser = state.list.filter(
				(staff) => staff.id !== parseInt(action.payload) && staff
			);

			state.list = filterUser;
		});

		builder.addCase(deleteStaff.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default userSlice.reducer;
export const { clearUser } = userSlice.actions;
